<div class="card-container" [class]="theme">
  <mat-card appearance="outlined" [class]="corners" >
    <mat-card-header>
      <mat-card-title>
        <ng-content select="carm-card-title"></ng-content>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <ng-content select="carm-card-content"></ng-content>
    </mat-card-content>
  </mat-card>
</div>
